import DashboardOverview from './component';
import {ThemeProvider} from '@mui/material';
import theme from '../../../theme';
const DashboardContainer = () => {
  return (
    <ThemeProvider theme={theme}>
      <DashboardOverview />
    </ThemeProvider>
  );
};

export default DashboardContainer;
